// src/layouts/AdminLayout.jsx
import React from "react";
import { FileText } from "lucide-react";
import { Bell } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  MessageSquareText,
  Globe,
  LogOut,
} from "lucide-react";
import { clearAdminToken } from "../admin/auth";

export default function AdminLayout() {
  const navigate = useNavigate();

  const onLogout = () => {
    clearAdminToken();
    navigate("/admin/login", { replace: true });
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 rounded-lg transition ${
      isActive
        ? "bg-[#4A9FD8] text-white"
        : "text-slate-700 hover:bg-slate-100"
    }`;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <div className="flex">
        {/* Sidebar */}
        <aside className="w-72 min-h-screen border-r bg-white flex flex-col">
          <div className="p-5 border-b">
            <div className="text-lg font-extrabold">
              لوحة التحكم
              <span className="text-[#4A9FD8]"> Alalimi</span>
            </div>
            <div className="text-xs text-slate-500 mt-1">
              إدارة الاستضافة والعملاء
            </div>
          </div>

          <nav className="p-4 space-y-2 flex-1">
            <NavLink to="/admin" end className={linkClass}>
              <LayoutDashboard size={18} />
              الإحصائيات
            </NavLink>

            <NavLink to="/admin/leads" className={linkClass}>
              <MessageSquareText size={18} />
              تواصل معنا
            </NavLink>

            <NavLink to="/admin/clients" className={linkClass}>
              <Users size={18} />
              العملاء
            </NavLink>

            <NavLink to="/admin/websites" className={linkClass}>
              <Globe size={18} />
              المواقع
            </NavLink>
			
			<NavLink to="/admin/invoices" className={linkClass}>
			  <FileText size={18} />
			  الفواتير
			</NavLink>
			
			<NavLink to="/admin/renewals" className={linkClass}>
			  <Bell size={18} />
			 نبيهات التجديد
			</NavLink>
          </nav>

          <div className="p-4 border-t">
            <button
              onClick={onLogout}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg border hover:bg-slate-100"
            >
              <LogOut size={18} />
              تسجيل الخروج
            </button>
          </div>
        </aside>

        {/* Content */}
        <main className="flex-1">
          <header className="h-16 bg-white border-b flex items-center justify-between px-6">
            <div className="font-semibold">لوحة التحكم</div>
            <div className="text-sm text-slate-500">Admin</div>
          </header>

          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
